import React from "react";
import { Card, Form, Checkbox, Divider, Button, InputNumber, Col, Row, Modal, Input, message,Radio,Upload,Spin,Icon,DatePicker,Tooltip} from 'antd';
// import TitleTop from '@pages/Assembly/titleTop';
import NHFetch from "../../../utils/NHFetch";
import NHSelect from "../../common/NHSelect";
import NHFormItem from '../../common/NHFormItem';
import { getLoginUser,createUuid } from "../../../utils/NHCore";
import PropTypes from 'prop-types';
import {NHModal, NHConfirm} from '../../common/NHModal';
const Dragger = Upload.Dragger;
const FormItem = Form.Item;
const CheckboxGroup = Checkbox.Group;
const { TextArea } = Input;
const basicUrl = "/yxxc/";
const hjdm = "GD001_2";   //环节代码
const jfxtBasicUrl = 'api/zhxg-jfxt/';

/**
 * 绿色通道
 * Author: zengxiangkai@ly-sky.com
 * Created on: 2018-06-26
 * Version: 1.0
 * Modify log:
 */
class Lstd extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            editable: true,
            show: false,
            lstdBlyy: [], //绿色通道办理原因列表
            lstdHjsqdx:[],//绿色通道缓交申请对象列表
            hjblztData: {}, //环节办理状态信息
            lstdData: {}, //学生绿色通道办理信息
            fileList: [],
            uploading:false,
            yjje: 0,
            studentData: {},
            loading: false,
            previewVisible: false,
            judgeImgList: ['.png', '.PNG', '.jpg', '.JPG', '.bpm', '.BPM', '.jpeg', '.JPEG'],   //可以导入的图片格式
            judgeFileList: ['.pdf', '.PDF', '.doc', '.DOC', '.zip', '.ZIP', '.txt', '.TXT', '.xls', '.XLS', '.rar', '.RAR'],  //可以导入的非图片格式
            dkyhmc: '',
            dkyhList: [],//贷款银行
            dkfsList:[],//申请类型数据
            dkfsValue:"",//申请类型值
            lstdList:[{value:'1',label:"是"},{value:'0',label:"否"}],//申请类型数据
            sqValue:"",//是否申请绿色通道
            x_hjjzrq:"",
            jfhjzt:false,//缴费环节状态
        }
    }

    //渲染前获取 绿色通道办理原因
    componentDidMount() {
        // this.getDmkMc();
        this.loadLstddkfs();
        this.getLstdBlyy();
        this.getHjsqdx();
        this.getJfhjData();
        this.getSfsqLstd();
    }

    // 获取绿色通道是否办理选项
    getSfsqLstd=()=>{
        NHFetch('front/zhxg-unauth/yxwz/proData/selectDataList','get','sign=dmk_YXXT_LSTD_BLZT').then(res=>{
            if(res){
                if(res.data){
                    this.setState({
                        lstdList:res.data
                    })
                }
            }
        })
    }

    // 获取缴费环节状态
    getJfhjData = ()=>{
        let xsid = this.props.studentData.xsid;
        let param = {
            xsid:xsid,
            hjdm:'GD008_1'
        }
        NHFetch('api/zhxg-yxwz/zzbdCommon/getBlztByHjdm','GET',param).then(res =>{
            if(res){
                if(res.data == '1'){
                    this.setState({
                        jfhjzt:true
                    })
                }else{
                    this.setState({
                        jfhjzt:false
                    })
                }
            }
        })
    }

    componentWillReceiveProps(nextProps) {

        if ('studentData' in nextProps) {
            const studentData = nextProps.studentData;

            //查询到学生信息时才显示绿色通道环节办理业务项
            if (Object.keys(studentData).length !== 0) {

                //查询到不同学生，查找该学生应缴费用
                if (JSON.stringify(this.state.studentData) === '{}' || this.state.studentData !== studentData) {
                    this.setState({ studentData: studentData });
                    // this.getLstdYjjeData(studentData);
                    this.getLstdData();
                }
                this.setState({ show: true });

            } else {
                this.setState({ show: false });
            }
        }

        if ('hjblztData' in nextProps) {
            const hjblztData = nextProps.hjblztData;
            const lstdData = this.state.lstdData;

            if (hjblztData) {
                this.setState({ hjblztData: hjblztData});
            } else {
                this.setState({ hjblztData: hjblztData});
            }
            /* if (lstdData.sjly == 2) {
                this.setState({ editable: false });
            } */

        }

    }


    //获取下拉列表value对应的名称
    getDmkMc = (lstdData) => {
        NHFetch("front/zhxg-unauth/yxwz/proData/selectDataList", "GET",'sign=dmk_YXWZ_DKYH' )
            .then(res => {
                if (res.data) {
                    let list = [];
                    let dkyh = res.data;
                        dkyh.map(initItem => {
                            list.push({ label: initItem.LABEL, value: initItem.VALUE })
                        });
                        this.setState({ dkyhList: list },()=>{
                            this.getDkyhMc(lstdData);
                        });
                }
            });
    }

    /**
     * * 获取绿色通道办理原因
     *
     * @memberof Lstd
     */
     getLstdBlyy = () => {
        NHFetch(basicUrl + "getLstdBlyy", "GET")
            .then(res => {
                if (res) {
                    if (res.data) {
                        let col = [];
                        res.data.map(item => {
                            col.push(
                                <Col span={12}>
                                    <Checkbox value={item.VALUE}>
                                        {item.LABEL}
                                    </Checkbox>
                                </Col>
                            );
                        });
                        let html = <Row>{col}</Row>
                        this.setState({
                            lstdBlyy: html,
                        });
                    }
                }
            });
    }

    /**
     * * 获取绿色通道缓交申请对象
     *
     * @memberof Lstd
     */
     getHjsqdx = () => {
        NHFetch("front/zhxg-unauth/yxwz/proData/selectDataList", "GET",'sign=dmk_YXXT_LSTD_HJSQDXLX')
            .then(res => {
                if (res) {
                    if (res.data) {
                        let col = [];
                        res.data.map(item => {
                            if(item.VALUE == '7'){
                                col.push(
                                    <Col span={12}>
                                        <Tooltip placement="bottom" title="主要包括扶贫部门监测的边缘户；享受国家定期抚恤补助的优抚对象子女；家庭经济困难残疾人子女；因家庭遭受重大自然灾害（疫情）造成重大损失的困难家庭子女；因家庭成员遭受重大疾病或意外伤害的困难家庭子女；因家庭发生重大变故等影响其子女入学就读的困难家庭子女；其他需要资助的低收入家庭经济困难学生。">
                                            <Checkbox value={item.VALUE}>
                                                {item.LABEL}
                                            </Checkbox>
                                        </Tooltip>
                                        </Col>
                                );
                            }else{
                                col.push(
                                    <Col span={12}>
                                        <Checkbox value={item.VALUE}>
                                            {item.LABEL}
                                        </Checkbox>
                                    </Col>
                                );
                            }
                        });
                        let html = <Row>{col}</Row>
                        this.setState({
                            lstdHjsqdx: html,
                            hjsqdxlx:res.data
                        });
                    }
                }
            });
    }

    /**
     * 获取贷款银行名称
     */
    getDkyhMc(lstdData) {
        let dkyhmc = '';
        this.state.dkyhList.map(initItem => {
            console.log(initItem,lstdData.dkyh);
            if (initItem.value == lstdData.dkyh) {
                dkyhmc = initItem.label;
            }
        });
        this.setState({ dkyhmc: dkyhmc });
    }

    /* 
    **获取申请类型数据
    *
    */
    // 申请类型
    loadLstddkfs=()=>{
        NHFetch('front/zhxg-unauth/yxwz/proData/selectDataList','get','sign=dmk_YXXT_DKLX').then(res=>{
            if(res && res.code == 200){
                let list = []
                let dkfsList = res.data;
                dkfsList.map((item)=>{
                     list.push({"value":item.VALUE,"label":item.LABEL})
                })
                 this.setState({
                    dkfsList:list
                 })
             }
        });
    }


    /**
     * * 获取学生应缴费用信息
     *
     * @memberof Lstd
     */
    /* getLstdYjjeData = (studentData) => {
        const { xsid } = studentData;
        NHFetch(jfxtBasicUrl + 'yxjk/getTotalYjje', 'GET', { xsid: xsid })
            .then(res => {
                if (res && res.data) {
                    this.setState({ yjje: res.data });
                } else {
                    this.setState({ yjje: 0 });
                }
            })
    } */

    /**
     * * 获取绿色通道办理原因
     *
     * @memberof Lstd
     */

    /**
     * * 获取学生绿色通道办理数据
     *
     * @memberof Lstd
     */
/*     getLstdData = (studentData) => {
        const { xsid } = studentData;
        NHFetch('api/zhxg-yxxt/yxwz/zzbd/lstdFb/getLstdInfoByXsid', 'GET', { xsid: xsid }).then(resData => {})
        NHFetch(basicUrl + 'getLstdData', 'GET', { xsid: xsid })
            .then(res => {
                if (res && res.data) {
                    this.setState({ lstdData: res.data , editable: false });
                    this.getDkyhMc(res.data);

                }else if(res.data == null){
                    this.setState({lstdData: {} , editable: true });

                }

            }).catch((ress) => {
                this.setState({ lstdData: {}, dkyhmc: '无' });
            })
    }

    //读取学生的绿色通道信息 */
    getLstdData = () => {
        const { xsid } = this.props.studentData;
        NHFetch('api/zhxg-yxxt/yxwz/zzbd/lstdFb/getLstdInfoByXsid', 'GET', { xsid: xsid }).then(resData => {
            if (resData && resData.data) {
                this.getDmkMc(resData.data);
                let fileList = [];
                if(resData.data && resData.data['fjmap']){
                    resData.data['fjmap'].map((elem,index)=>{
                        //格式化对于附件取值
                        let file = {
                            uid: elem.fjid,
                            name: elem.fjmc,
                            response:{
                                data:{
                                    ssbh:elem.fjid,
                                    fjmc:elem.fjmc,
                                }
                            },
                            status: 'done'
                        }
                        fileList.push(file);
                    })
                }
                this.setState({fileList:fileList});
                this.props.form.setFieldsValue({fj:{fileList:this.state.fileList}});
                this.setState({ lstdData:resData.data, dkfsValue:resData.data.dklx, editable: false,sqValue:resData.data.sfbllstd})
            }else if(resData.data == null){
                this.setState({lstdData: {} , editable: true });

            }
        }).catch((ress) => {
            this.setState({ lstdData: {}, dkyhmc: '无' });
        });
    }


    //取消办理
    handleCancel = () => {
        if(this.state.jfhjzt){
            message.warning("缴费环节已办理，不能取消办理！");
            return;
        }
        const { pkid } = this.state.hjblztData;
        const { xsid } = this.state.studentData;
        let userId = getLoginUser() ? getLoginUser().userId : '';  
        let params = { xsid: xsid, hjdm: hjdm, yhbh: userId,  lchjid: pkid };
        NHConfirm("是否确定取消办理？取消办理前，请确认是否在财务系统已撤销缓交记录？",() => {
            this.setState({ loading: true })
            NHFetch(basicUrl + 'cancelCustomLinkData', 'POST', params)
                .then(res => {
                    if (res) {
                        if (res.data == '1') {
                            this.setState({ loading: false,editable:true,dkfsValue:'',sqValue:'' })
                            this.props.form.setFieldsValue({fj:{fileList:[]}});
                            message.success('环节办理取消成功！');
                            //取消办理完成回调
                            this.getLstdData(this.state.studentData);
                            const onFinish = this.props.onFinish;
                            if (onFinish) {
                                onFinish('cancel');
                            }
                        } else {
                            this.setState({ loading: false })
                            message.error('环节办理取消失败，请重试！');
                        }
                    }
                })
        },"warn");
    }

    //打印报到单回调
    handlePrint = () => {
        let onPrint = this.props.onPrint;
        if (onPrint) {
            onPrint();
        }
    }

    //上一步
    handleLast = () => {
        let onLast = this.props.onLast;
        if (onLast) {
            onLast();
        }
    }

    //下一步
    handleNext = () => {
        let onNext = this.props.onNext;
        if (onNext) {
            onNext();
        }
    }

    //判断文件类型是否正常  name：文件名称  map：类型范围数组
    setJudge = (name, map) => {
        let flag = false;
        map.map(item => {
            if (name.indexOf(item) !== -1) {
                flag = true;
            }
        })
        return flag;
    }


    // 点击文件链接或预览图标时的回调
    handlePreview = (fjmc, fjid) => {
        let isImage = this.setJudge(fjmc, this.state.judgeImgList);

        if (isImage) {
            this.showPreview(`api/docrepo/download/file?attachmentId=${fjid}`);
        } else {
            window.open(`api/docrepo/download/file?attachmentId=${fjid}`);
        }
    };

    //打开图片弹窗
    showPreview = (url) => {
        this.setState({
            previewImage: url,
            previewVisible: true
        });
    }
    // 关闭图片弹窗
    closeModal = () => this.setState({ previewVisible: false });

    // 提交办理
    handleSubmit = e => {
        if(this.state.jfhjzt){
            message.warning("缴费环节已办理，不能办理该环节！");
            return;
        }
        const { xsid } = this.props.studentData;
        const { pkid } = this.state.hjblztData;
        let userId = getLoginUser() ? getLoginUser().userId : '';
        this.setState({loading:true});
        e.preventDefault();
        this.props.form.validateFieldsAndScroll((err, values) => {
            if(err){
                this.setState({loading:false});
                return false;
            }
            let fjlist = [];

            if(values['sfbllstd'] != 0){
                    const fj = values['fj'];
                    let isEmpty = false;
                    if(values['dklx']  == '5' || values['dklx']  == 'whrj_1' ||values['dklx']  == 'whrj_4'){
                        if(fj){
                            if(fj['fileList'] && fj['fileList'].length>0){
                                isEmpty = false;
                            }else{
                                isEmpty = true;
                            }
                        }else{
                            isEmpty = true;
                        }
                        if(isEmpty){
                            this.props.form.setFields({
                                fj:{
                                    value:undefined,
                                    errors:[new Error('请上传材料证明')],
                                }
                            });
                            this.setState({loading:false});
                            return false;
                        }
                    }
                    if(fj != undefined){
                        let size = fj['fileList'].length;
                        let file = fj['fileList'].filter((file) => {
                            if (file.status==='error') {
                                return false;
                            }
                            return true;
                        });
                    
                    if(file.length!=size){
                        this.props.form.setFields({
                            fj:{
                                value:fj,
                                errors:[new Error('材料上传出错，请重新上传.')],
                            }
                        });
                        this.setState({loading:false});
                        return false;
                    }
        
                    let fileList = fj['fileList'];
                    
                    for(let i=0;i<fileList.length;i++){
                        let fjid = fileList[i].response.data.ssbh;
                        let fjmc = fileList[i].name;
                        fjlist.push({
                            fjid:fjid,
                            fjmc:fjmc
                        });
                    }
                }
            }

            let sqsm = values['sqsm'];
            let dkyh = values['dkyh'];
            let hzjym = values['hzjym'];
            let dkhtbh = values['dkhtbh'];
            let blje = values['blje'];
            let dklx  = values['dklx'];
            let blyy = values['blyy'];
            let x_djlqzy = values['x_djlqzy']
            let x_hjjzrq = this.state.x_hjjzrq;
            let x_hjsqdxlx = values['x_hjsqdxlx']
            if(x_hjsqdxlx){
                x_hjsqdxlx =  x_hjsqdxlx.toString();
            }
            let sfbllstd = values['sfbllstd']
           
            let formData = {};
            if(values['sfbllstd'] != '0'){
                if(fjlist.length > 0){
                    formData = {
                        fj:fjlist,
                        blje:blje,
                        sqsm:sqsm,
                        hzjym:hzjym,
                        dkyh:dkyh,
                        dkhtbh:dkhtbh,
                        dklx:dklx,
                        x_djlqzy:x_djlqzy,
                        sfbllstd,
                        blyy
                    }
                }else{
                    formData = {
                        blje:blje,
                        sqsm:sqsm,
                        hzjym:hzjym,
                        dkyh:dkyh,
                        dkhtbh:dkhtbh,
                        dklx:dklx,
                        x_djlqzy:x_djlqzy,
                        sfbllstd,
                        blyy
                    }
                }
            }else{
                formData = {
                    sfbllstd,
                }

            }
            if(values['dklx'] == 'whrj_4'){
                formData['x_hjjzrq'] = x_hjjzrq;
                formData['x_hjsqdxlx'] = x_hjsqdxlx;
            }
            let params = { xsid: xsid, lchjid: pkid, formData: formData, yhbh: userId, hjdm: hjdm };
            console.log(params);
            NHFetch(basicUrl + 'saveCustomLinkData', 'POST', params)
                .then(res => {
                    if (res) {
                        if (res.data == '1') {
                            this.setState({ loading: false })
                            message.success('环节办理成功！');
                            this.getLstdData(this.state.studentData);
                            //办理完成回调
                            const onFinish = this.props.onFinish;
                            if (onFinish) {
                                onFinish('submit');
                            }
                        } else {
                            this.setState({ loading: false })
                            message.error('环节办理失败，请重试！');
                        }
                    }
                    this.setState({ loading: false })
                })
        });
    };

    //判断文件类型是否正常  name：文件名称  map：类型范围数组  true正常
    setJudge = (name, map) => {
        let flag = false;
        map.map(item => {
            if (name.indexOf(item) !== -1) {
                flag = true;
            }
        })
        return flag;
    }

    // 上传前
    beforeUpload = (file) => {
            if (
                !(this.setJudge(file.name, this.state.judgeImgList) ||
                this.setJudge(file.name, this.state.judgeFileList))
            ) {
                message.error('不能上传该格式文件');
                return false;
            } else {
                return true;
            }
    }

    // 移除图片
    remove=(ssbh)=>{
        let url = `api/docrepo/attachment/sourceId/delete?souerceId=${ssbh}`;
        NHFetch(url,"POST").then(res => {
            if (res.data && res.data > 0) {
                message.success('已删除材料.');
            }
        });
    }

    // 上传回调
    handleChange = ({ fileList } ) => {
        let count = 0;
        fileList.map((elem)=>{
            if(elem && elem['status'] && elem['status']==='uploading'){
                this.setState({uploading:true});
                return;
            }else if(elem && elem['status']){
                count++;
            }
        })
        if(count>0){
            this.setState({uploading:false});
        }
    }

    unploadPreview = file => {
        const isImage = /^image\/.*$/i.test(file.type);
        if (isImage) {
            if (file) {
                this.getBase64(file, imageUrl => {
                    this.setState({
                        previewImage: imageUrl,
                        previewVisible: true
                    });
                });
            } else {
                this.setState({
                    previewImage: file.url || file.thumbUrl,
                    previewVisible: true
                });
            }
        }else if(file && file['response'] && file['response']['data']){//其他情况
            let isImage = true;
            let fjmc = file['response']['data']['fjmc'];
            let ssbh = file['response']['data']['ssbh'];
            if (
                !this.setJudge(fjmc,this.state.judgeImgList)
            ) {
                isImage = false;
            }

            if (isImage) {
                this.showPreview(`anonymity/docrepo/download/file?attachmentId=${ssbh}`);
            } else {
                window.open(`anonymity/docrepo/download/file?attachmentId=${ssbh}`);
            }
        }
    };

    // 申请类型回调
    dkfsOnChange = e => {
        console.log('radio checked', e.target.value);
        this.setState({
            dkfsValue: e.target.value,
        });
    };

    sqOnChange = e => {
        console.log('radio checked', e.target.value);
        this.setState({
            sqValue: e.target.value,
        });
    };

     //选择缓交截止日期回调
     timeData=(moment,timeString)=>{
        console.log(moment,timeString);
        this.setState({
            x_hjjzrq:timeString
        })
    }

    render() {
        const { form, lchjData = {}, hasLast, hasNext } = this.props;
        const { editable, lstdBlyy,show, lstdData, yjje, loading, previewVisible, previewImage, dkyhmc,lstdList,sqValue ,dkfsValue,lstdHjsqdx,dkfsList,hjsqdxlx} = this.state;

        let x_hjsqdxlxmc = '';
        if(lstdData['x_hjsqdxlx']){
            let x_hjsqdxlxdm = lstdData['x_hjsqdxlx'].split(',');
            if(hjsqdxlx){
                hjsqdxlx.map((item,index)=>{
                    x_hjsqdxlxdm.map((elem)=>{
                        if(item.VALUE==elem){
                            if(index==0){
                                x_hjsqdxlxmc += item.LABEL;
                            }else{
                                x_hjsqdxlxmc += ',' + item.LABEL;
                            }
                        }
                    })
                })
            }
        }

        let lstdBlzt = "";
        if(lstdData['sfbllstd']){
            if(lstdList){
                lstdList.map((item,index)=>{
                    if(lstdData['sfbllstd'] == item.VALUE){
                        lstdBlzt = item.LABEL;
                    }
                })
            }
        }

        const { sfdybdd = '0' } = lchjData; //是否打印报到单

        const formItemLayout = { //表单项布局
            labelCol: {
                xs: { span: 24 },
                sm: { span: 12 },
                md: { span: 10 },
                lg: { span: 4 },
            },
            wrapperCol: {
                xs: { span: 24 },
                sm: { span: 12 },
                md: { span: 10 },
                lg: { span: 16 },
            }
        }

        const { getFieldDecorator } = this.props.form;

        const props = {
            name: 'file',
            action: 'zuul/docrepo/upload',
            data: { uuid: createUuid(), type: '1' },

            onRemove: file => {
                this.setState(({ fileList }) => {
                    const index = fileList.indexOf(file);
                    const newFileList = fileList.slice();
                    newFileList.splice(index, 1);
                    this.props.form.setFieldsValue({fj:{fileList:newFileList}});
                    return {
                        fileList: newFileList
                    };
                },()=>{
                    if(file.response && file.response.data && file.response.data.ssbh){
                        this.remove(file.response.data.ssbh);
                    }
                });
            },
            beforeUpload: file => {
                if(!this.beforeUpload(file)){
                    return false;
                }
                console.log("fileList---","file--",file);
                this.setState(({ fileList }) => ({
                    fileList: [...fileList, file]
                }));
                return true;
            },
            onChange:file=>{this.handleChange(file)},
            onPreview: this.unploadPreview,
            fileList:this.state.fileList,
        };

        return (

            <div>

                <Card type="inner" title="绿色通道业务信息">
                    {
                        editable ?
                            <div>
                                {
                                    show ?
                                        <Form>
                                            <NHFormItem id={"sfbllstd"} label="绿色通道申请" form={form} required={true}
                                                formItemLayout={formItemLayout} >
                                                <Radio.Group onChange={this.sqOnChange} value={this.state.sqValue} style={{display:"flex",margin:"10px"}} >
                                                    {
                                                        lstdList.map((item,index)=>{
                                                            return  <Radio value={item.VALUE}>{item.LABEL}</Radio>
                                                        })
                                                    }
                                                </Radio.Group>
                                            </NHFormItem>

                                            {sqValue=='1' && <NHFormItem id={"dklx"} label="申请类型" form={form} required={true}
                                                formItemLayout={formItemLayout}>
                                                <Radio.Group onChange={this.dkfsOnChange} value={this.state.dkfsValue} style={{display:"flex",margin:"10px"}} >
                                                    {
                                                        dkfsList.map((item,index)=>{
                                                            return  <Radio value={item.value}>{item.label}</Radio>
                                                        })
                                                    }
                                                </Radio.Group>
                                            </NHFormItem>}

                                            {sqValue=='1'&& dkfsValue=='whrj_1' &&<NHFormItem id={"blyy"} label="办理原因" form={form} required={true}
                                                formItemLayout={formItemLayout}>
                                                <Checkbox.Group
                                                    style={{ width: '100%' }}
                                                >
                                                    {lstdBlyy}
                                                </Checkbox.Group>
                                            </NHFormItem>}
                                            {sqValue=='1'&& dkfsValue=='whrj_4' &&<NHFormItem id={"x_hjsqdxlx"} label="缓交申请对象" form={form} required={true}
                                                formItemLayout={formItemLayout}>
                                                <Checkbox.Group
                                                    style={{ width: '100%' }}
                                                >
                                                    {lstdHjsqdx}
                                                </Checkbox.Group>
                                            </NHFormItem>}

                                            {sqValue=='1'&&(dkfsValue=='1'|| dkfsValue=='whrj_1') && <NHFormItem id={"blje"} label="贷款金额" form={form} required={true}
                                                formItemLayout={formItemLayout}>
                                                <InputNumber
                                                    style={{ width: '50%' }}
                                                    formatter={value => `￥ ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                                                    parser={value => value.replace(/\￥\s?|(,*)/g, '')}
                                                    precision="0"
                                                    // max={yjje}
                                                    max={9999999}
                                                    min={0}
                                                    step={100}
                                                />
                                            </NHFormItem>}

                                            {sqValue=='1'&&(dkfsValue=='4'||dkfsValue=='whrj_4') && <NHFormItem id={"blje"} label="缓交金额" form={form} required={true}
                                                formItemLayout={formItemLayout}>
                                                <InputNumber
                                                    style={{ width: '50%' }}
                                                    formatter={value => `￥ ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                                                    parser={value => value.replace(/\￥\s?|(,*)/g, '')}
                                                    precision="0"
                                                    // max={yjje}
                                                    max={9999999}
                                                    min={0}
                                                    step={100}
                                                />
                                            </NHFormItem>}

                                            {sqValue=='1'&& dkfsValue=='5' && <NHFormItem id={"blje"} label="减免金额" form={form} required={true}
                                                formItemLayout={formItemLayout}>
                                                <InputNumber
                                                    style={{ width: '50%' }}
                                                    formatter={value => `￥ ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                                                    parser={value => value.replace(/\￥\s?|(,*)/g, '')}
                                                    precision="0"
                                                    // max={yjje}
                                                    max={9999999}
                                                    min={0}
                                                    step={100}
                                                />
                                            </NHFormItem>}

                                            {sqValue=='1'&&(dkfsValue=='1'||dkfsValue=='whrj_1') && <NHFormItem id={"dkyh"} label="贷款银行" form={form} required={true}
                                                formItemLayout={formItemLayout}>
                                                <NHSelect style={{ width: '50%' }} sign={"dmk_yxwz_dkyh"} />
                                            </NHFormItem>}

                                            {sqValue=='1'&&(dkfsValue=='1'||dkfsValue=='whrj_1') && <NHFormItem id={"hzjym"} label="6位数回执校验码" form={form} required={true}
                                                formItemLayout={formItemLayout}>
                                                <Input style={{ width: '50%' }} maxLength={6} placeholder="6位数回执校验码" />
                                            </NHFormItem>}

                                            {sqValue=='1'&&dkfsValue=='1' && <NHFormItem id={"dkhtbh"} label="贷款合同编号" form={form} required={true}
                                                formItemLayout={formItemLayout}>
                                                <Input style={{ width: '50%' }} placeholder="贷款合同编号" />
                                            </NHFormItem>}

                                            {sqValue=='1'&&dkfsValue=='5' && <NHFormItem required={true} id={'x_djlqzy'} form={form}  formItemLayout = {formItemLayout} label="登记录取专业">
                                                <Input style={{ width: '50%' }} placeholder="登记录取专业" />
                                            </NHFormItem>}

                                            {sqValue=='1'&&dkfsValue=='whrj_4' && <NHFormItem required={true} id={'x_hjjzrq'} form={form}  formItemLayout = {formItemLayout} label="缓交截止时间">
                                                {/* <Input style={{ width: '50%' }} placeholder="缓交截止时间" /> */}
                                                <DatePicker
                                                    mode="date"
                                                    title="缓交截止时间"
                                                    extra="请选择..."
                                                    format="YYYY-MM-DD"
                                                    onChange={this.timeData}
                                                    >
                                                </DatePicker>
                                            </NHFormItem>}

                                            {(dkfsValue=='1' || dkfsValue== '4'||dkfsValue=='whrj_1')&&<NHFormItem id={"sqsm"} label="申请理由" form={form} required={dkfsValue== '4'?true:false}
                                                formItemLayout={formItemLayout}>
                                                <TextArea maxLength={50} placeholder="请填写申请理由" />
                                            </NHFormItem>}

                                            {/* {dkfsValue!='6' && dkfsValue != '' && dkfsValue!=undefined && <TitleTop title="申请材料" extra={false} />} */}
                                            {sqValue=='1'&&dkfsValue!='6' && dkfsValue != '' && dkfsValue!=undefined && <div className="p-sw">
                                                <div className="form_item" style={{marginLeft: '7%'}}>
                                                    <FormItem
                                                        labelCol= { {span: 3} }
                                                        wrapperCol={ {span: 16} }
                                                        label={'请上传材料证明'}
                                                    >
                                                        {getFieldDecorator('fj', {
                                                            rules: [
                                                                {
                                                                    required: (dkfsValue=='5'||dkfsValue=='whrj_1'||dkfsValue=='whrj_4') ? true : false,
                                                                    message:'请上传材料证明'
                                                                }
                                                            ]
                                                        })(
                                                            <Dragger {...props}>
                                                                <p className="ant-upload-drag-icon">
                                                                    <Icon type="inbox" />
                                                                </p>
                                                                <Spin spinning={this.state.uploading}/>
                                                                <p className="ant-upload-text font-14">
                                                                    点击此处或拖拽文件到此
                                                                </p>
                                                            </Dragger>
                                                        )}
                                                    </FormItem>
                                                </div>
                                            </div>}
                                        </Form>
                                        : null
                                }
                            </div>
                            :
                            <div>
                                <Form>
                                    <FormItem {...formItemLayout} label={'绿色通道申请'}>
                                        <span>{lstdBlzt}</span>
                                    </FormItem>
                                    {lstdData['sfbllstd']=="1" && <FormItem {...formItemLayout} label={'申请类型'}>
                                        <span>{lstdData['dklxmc']?lstdData['dklxmc']:""}</span>
                                    </FormItem>}
                                    {lstdData['sfbllstd']=="1" && lstdData['dklx'] == 'whrj_1' && <FormItem {...formItemLayout} label={'办理原因'}>
                                        <span>{lstdData.blyy}</span>
                                    </FormItem>}
                                    {lstdData['sfbllstd']=="1" && lstdData['dklx'] == 'whrj_4' && <FormItem {...formItemLayout} label={'缓交申请对象'}>
                                        <span>{x_hjsqdxlxmc}</span>
                                    </FormItem>}
                                    {lstdData['sfbllstd']=="1" && lstdData['dklx'] == 'whrj_4' && <FormItem {...formItemLayout} label={'缓交截止时间'}>
                                        <span>{lstdData['x_hjjzrq']}</span>
                                    </FormItem>}
                                    {lstdData['sfbllstd']=="1" &&lstdData['dklx'] != '4'&& lstdData['dklx'] != '5' && lstdData['dklx'] != '6' && lstdData['dklx'] != 'whrj_4' && <FormItem {...formItemLayout} label={'贷款金额'}>
                                        <span>{lstdData['blje']?lstdData['blje']:""}元</span>
                                    </FormItem>}
                                    {lstdData['sfbllstd']=="1" && (lstdData['dklx'] == '4'||lstdData['dklx'] == 'whrj_4') && <FormItem {...formItemLayout} label={'缓交金额'}>
                                        <span>{lstdData['blje']?lstdData['blje']:""}元</span>
                                    </FormItem>}
                                    {lstdData['sfbllstd']=="1" && lstdData['dklx'] == '5' && <FormItem {...formItemLayout} label={'减免金额'}>
                                        <span>{lstdData['blje']?lstdData['blje']:""}元</span>
                                    </FormItem>}
                                    {lstdData['sfbllstd']=="1" && (lstdData['dklx'] == '1'|| lstdData['dklx'] == 'whrj_1') && <FormItem {...formItemLayout} label={'贷款银行'}>
                                        <span>{dkyhmc}</span>
                                    </FormItem>}
                                    {lstdData['sfbllstd']=="1" && (lstdData['dklx'] == '1'|| lstdData['dklx'] == 'whrj_1') && <FormItem {...formItemLayout} label={'6位数回执校验码'}>
                                    <span>{lstdData['hzjym']?lstdData['hzjym']:""}</span>
                                    </FormItem>}
                                    {lstdData['sfbllstd']=="1" && lstdData['dklx'] == '1' && <FormItem {...formItemLayout} label={'贷款合同编号'}>
                                    <span>{lstdData['dkhtbh']?lstdData['dkhtbh']:""}</span>
                                    </FormItem>}
                                    {lstdData['sfbllstd']=="1" && lstdData['dklx'] == '5' && <FormItem {...formItemLayout} label={'登记录取专业'}>
                                        <span>{lstdData['x_djlqzy']?lstdData['x_djlqzy']:""}</span>
                                    </FormItem>}
                                    {lstdData['sfbllstd']=="1" && lstdData['dklx'] != '6' && lstdData['dklx'] != '5'&& lstdData['dklx'] != 'whrj_4' && <FormItem {...formItemLayout} label={'申请理由'}>
                                        <span>{lstdData['sqsm']?lstdData['sqsm']:""}</span>
                                    </FormItem>}

                                    {/* {lstdData['dklx'] != '6' && <TitleTop title="申请材料附件" extra={false}/>} */}
                                    {lstdData['sfbllstd']=="1" && lstdData['dklx'] != '6' && <div className="p-sw">
                                        <div className="form_item" style={{width: '100%' }}>
                                        <FormItem {...formItemLayout} label={'申请材料附件'}>
                                                <span>
                                                    {lstdData['fjmap'] && lstdData['fjmap'].map((elem, index) => {
                                                        return (
                                                            <div style={{marginBottom: '20px'}}>
                                                                <a onClick={() => {
                                                                    this.handlePreview(elem['fjmc'], elem['fjid']);
                                                                }}>{elem['fjmc']}</a>
                                                            </div>
                                                        )
                                                    })
                                                    }
                                                </span>
                                        </FormItem>
                                        </div>
                                    </div>}

                                </Form>

                                <Modal
                                    visible={previewVisible}
                                    footer={null}
                                    onCancel={this.closeModal}
                                >
                                    <img
                                        alt="example"
                                        style={{ width: '100%' }}
                                        src={previewImage}
                                    />
                                </Modal>

                            </div>
                    }
                </Card>
                <Divider style={{ margin: '40px 0 24px' }} />
                {
                    editable|| (lstdData['shzt'] == 0 || lstdData['shzt']  == 9)  ?
                        <Button type="primary" onClick={this.handleSubmit} loading={loading}>确认办理</Button>
                        : <Button type="primary" onClick={this.handleCancel} loading={loading}>取消办理</Button>
                }
                {
                    sfdybdd == '1' ? <Button type="primary" loading={this.props.loading} ghost style={{ marginLeft: 10 }} onClick={this.handlePrint}>打印报到单</Button> : null
                }
                {
                    hasLast ? <Button type="primary" ghost style={{ marginLeft: 10 }} onClick={this.handleLast}>上一步</Button> : null
                }
                {
                    hasNext ? <Button type="primary" ghost style={{ marginLeft: 10 }} onClick={this.handleNext}>下一步</Button> : null
                }
            </div>
        )
    }
}

Lstd.propTypes = {
    studentData: PropTypes.object, //学生信息
    hjblztData: PropTypes.object, //环节办理状态信息
    lchjData: PropTypes.object, //流程环节信息数据
    hasLast: PropTypes.bool, //是否有上一步
    hasNext: PropTypes.bool, //是否有下一步
    onLast: PropTypes.func, //上一步事件回调
    onNext: PropTypes.func, //下一步事件回调
    onFinish: PropTypes.func, //确认办理、取消办理完成回调
    onPrint: PropTypes.func, //打印报到单
}

const lstd = Form.create()(Lstd);
export default lstd;


// WEBPACK FOOTER //
// ./components/yxxc/steps/jhyszyLstd.js